const SUPPORT_TICKET_ATTACHMENT_UPLOAD_EVENT_NAME = 'SupportAttachmentUploadedEvent';

export { SUPPORT_TICKET_ATTACHMENT_UPLOAD_EVENT_NAME };
//# sourceMappingURL=SupportTicketAttachmentMapper.js.map
